import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d36fce2e"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LanguageSwitch: require('/app/components/base/LanguageSwitch/LanguageSwitch.vue').default,Icon: require('/app/components/base/Icon/Icon.vue').default,Headline: require('/app/components/base/Headline/Headline.vue').default,ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default,CmAccordion: require('/app/components/modules/CmAccordion/CmAccordion.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default,Footer: require('/app/components/app/Footer/Footer.vue').default})
